module.exports = __webpack_public_path__ + "static/media/icon_close.e575c8f9.svg";